import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import FolderClosedIcon from '@atlaskit/icon/core/folder-closed';
import PageIcon from '@atlaskit/icon/core/page';
import { SearchLinkSkeletons } from '@atlassian/dynamic-cards-search-page';
import { EmptyState, ResultContainer, SearchDialog, SearchDialogContent, SearchResult } from '@atlassian/search-dialog';
import { ContentType } from '../types';
import { SearchErrorImage } from './error-image';
import { messages } from './messages';
export var SearchDropdown = function SearchDropdown(_ref) {
  var hasQueryError = _ref.hasQueryError,
    inputWidth = _ref.inputWidth,
    isLoading = _ref.isLoading,
    data = _ref.data;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(SearchDialog
  /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */, {
    style: {
      boxShadow: 'none',
      width: inputWidth
    }
    /* eslint-enable @atlaskit/ui-styling-standard/enforce-style-prop */
  }, isLoading && /*#__PURE__*/React.createElement(SearchLinkSkeletons, null), (data && data.length === 0 || hasQueryError) && /*#__PURE__*/React.createElement(EmptyState, {
    title: formatMessage(messages.errorText),
    Image: SearchErrorImage,
    content: /*#__PURE__*/React.createElement(FormattedMessage, messages.tryAgain)
  }), data && data.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchDialogContent, null, /*#__PURE__*/React.createElement(ResultContainer, null, data.map(function (result) {
    return /*#__PURE__*/React.createElement(SearchResult, {
      key: result.id,
      href: result.url,
      title: result.title,
      isCollapsed: true,
      icon: result.type === ContentType.PAGE ? /*#__PURE__*/React.createElement(PageIcon, {
        label: ""
      }) : /*#__PURE__*/React.createElement(FolderClosedIcon, {
        label: ""
      })
    });
  })))));
};